import React from 'react';
import { splitNewLine } from './string';

const returnKey = (string) => {
	let code = 0;

	for (let i = 0; i < string.length; i += 1) {
		code = (code * 31) + string.charCodeAt(i);
		code &= code;
	}

	return code;
};

const newLine = (string, split = '\n') => string.split(split).map((item, k) => (k === 0 ? item : [<br />, item]));

const addLinks = (string, split = true) => {
	string = String(string);
	const parts = split ? splitNewLine(string) : string;

	return parts.map((p) => {
		if (p === '') return null;

		const email = p.match(/\b[a-z0-9.@\-_]+@[a-z0-9.@\-_]+\b/i);
		if (email) return <a href={`mailto:${email[0].toLowerCase()}`} target="_blank" rel="noopener noreferrer">{ `${email[0]}\n` }</a>;

		const link = p.match(/^\b[a-z0-9.@\-_]{3,}(\.[a-z]{2,})+\b/i);
		if (link) return <a href={`https://${link[0].toLowerCase()}`} target="_blank" rel="noopener noreferrer">{ `${link[0]}\n` }</a>;

		return <>{ `${p}\n` }</>;
	});
};

export { newLine, returnKey, addLinks };
